import { createSelector } from 'reselect'

import { getAnalytics } from './rootSelectors'

export const getAnalyticsTags = createSelector(getAnalytics, (analyticsState) => analyticsState.list)
